module.exports = __webpack_public_path__ + "static/ringondeli-a47ea25acee5cd5aef97d3f33b7dfa40.png";